import PropTypes from 'prop-types';
import React from 'react';
import HotelDocumentForm from './HotelDocumentForm';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Form, Button, Modal, FormGroup, InputGroup, ControlLabel, FormControl, ButtonToolbar } from 'react-bootstrap';
import AddHotelDocumentForm from './AddHotelDocumentForm';
import diff from 'object-diff';

class HotelDocuments extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
      isDeleting: false,
      document_id: '',
      initialValues: {},
      files: '',
      documents: ''
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.deleteDocument = this.deleteDocument.bind(this);
    this.handleShowConfirm = this.handleShowConfirm.bind(this);
    this.handleEditDocument = this.handleEditDocument.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }
  handleEdit(row) {
    
    this.setState({ isEditing: true, documents: '', initialValues: {document_name: row.document, document_option: row.is_existing_url, existing_url: row.existing_url, id: row.id}});
    if(!row.is_existing_url) {
      let documentName = this.getDocumentName(row);
      let files = (<ul className="list-group mt-2">
                    <li className="list-group-item list-group-item-success">
                      {documentName}
                    </li>
                </ul>)
      this.setState({
        files: files 
      })
    }
  }
  getDocumentName = (row) => {
    if(row.document_path) {
      return row.document_path.split('/').pop();    
    }else {
      return row.document;
    }
  }
  handleClose() {
    this.setState({ isEditing: false, files: ''});
    if(this.state.isDeleting){
      this.setState({
        isDeleting: false
      })
    }
  }
  handleShowConfirm(row) {
    this.setState({
      isDeleting: true,
      isEditing: true,
      document_id: row.id
    })
  }
  deleteDocument(){
    this.props.deleteHotelDocument(this.props.hotel.id, {document_id: this.state.document_id})
    this.setState({
      isEditing: false,
      isDeleting: false
    })
  }
  handleEditDocument(values) {
    const id = this.props.hotel.id;
    const is_existing_url = values.document_option;

    if(values.document_name) {
      let documentName = values.document_name;
        if(typeof(documentName) == undefined || documentName.trim() == '') {
        alert("Please provide document name");
        return
      }
    }

    if(is_existing_url){
      if(typeof(values.existing_url) == undefined || (values.existing_url == undefined ? values.existing_url == '' : (values.existing_url).trim() == '' ) || values.existing_url == undefined) {
        alert("Please provide document url");
        return
      }
    }else if(!is_existing_url) {
      if((typeof(this.state.documents) == undefined || this.state.documents == '') && this.state.files == '') {
        alert("Please select document to upload");
        return
      }
    }

    if(!is_existing_url && this.state.documents) {
      values['document'] = this.state.documents;
    }
    this.props.updateHotelDocument(id, values, (response) =>{
      this.handleClose();
    });
  }
  onDrop(acceptedFiles){
    if(acceptedFiles.length > 1){
      alert("Please select single document to upload.");
      return
    }
    let files = (<ul className="list-group mt-2">
                  {acceptedFiles.length > 0 && acceptedFiles.map(acceptedFile => (
                    <li className="list-group-item list-group-item-success">
                      {acceptedFile.name}
                    </li>
                  ))}
                </ul>)
    this.setState({
      documents: acceptedFiles,
      files: files
    })

    let submitBtn = document.getElementById('hotelDocumentSubmitBtn');
    submitBtn.disabled = false;

  }
  buttonFormatter = (cell, row) => <div>
        <ButtonGroup>
            <Button bsStyle="primary" title="Edit"
              onClick={() => this.handleEdit(row)}
            >
                <i className="fa fa-pencil fa-lg" />
            </Button>
        </ButtonGroup>
        <ButtonGroup className="hotel-document-delete-btn">
            <Button bsStyle="danger" title="Delete"
              onClick={() => this.handleShowConfirm(row)}
            >
                <i className="fa fa-trash-o fa-lg" />
            </Button>
        </ButtonGroup>
    </div>;
  render() {
      const documents = [];
      console.log("Hotel Documents",this.props.hotel.documents)
      this.props.hotel.documents.map(doc => {
          documents.push({
              id: doc.id,
              document: doc.document_name,
              is_existing_url: doc.is_existing_url,
              existing_url: doc.hotel_document_url,
              document_path: doc.hotel_document
          })
      })
      return (
        <div className="hotel-documents-section">
          <HotelDocumentForm
            {...this.props}
            handleClose={this.handleClose}
            addHotelDocument={this.props.addHotelDocument}
          />
          <div className="hotel-documents-table">
          {documents.length ? (<BootstrapTable
              data={documents}
              striped
              hover
              condensed
          >
              <TableHeaderColumn dataField="id" isKey hidden hiddenOnInsert={true}>Document ID</TableHeaderColumn>
              <TableHeaderColumn dataField="document">Document</TableHeaderColumn>
              <TableHeaderColumn dataField="editDocument" width="100" headerAlign="center" dataAlign="center" dataFormat={this.buttonFormatter} editable={false}>Action</TableHeaderColumn>
          </BootstrapTable>):(<p>No hotel document(s) available.</p>)}
          </div>
          {this.state.isEditing && (<Modal show={this.state.isEditing} onHide={this.handleClose} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>{this.state.isDeleting ? 'Delete Document' : 'Edit Document'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           {!this.state.isDeleting && (
            <AddHotelDocumentForm
              initialValues={this.state.initialValues}
              files={this.state.files}
              onSubmit={this.handleEditDocument}
              onDrop={this.onDrop}
            />
           )}
           {this.state.isDeleting && (
              <div>
                <p>Are your sure want to delete document?</p>
                <ButtonToolbar style={{ float: 'right' }}>
                  <Button
                    bsStyle="success"
                    onClick={this.deleteDocument}
                  >
                    Confirm
                  </Button>
                  <Button
                    bsStyle="success"
                    onClick={this.handleClose}
                  >
                    Cancel
                  </Button>
                </ButtonToolbar>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>)}
        </div>
        );

  }
}
HotelDocuments.propTypes = {
  hotel: PropTypes.object.isRequired
};

export default HotelDocuments;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelDocuments.js